export enum MicrositeRecipientCommunicationStatus {    
    Sent = 1,
    Viewed = 2,
    RepliedTo = 3
}